import { REPORT } from '@consts/reports';
import { CutsByLocationLastMonth } from '@components/reports/locations/CutsByLocationLastMonth';
import { CutsByLocationThisMonth } from '@components/reports/locations/CutsByLocationThisMonth';
import { CutsByLocation } from '@components/reports/locations/CutsByLocation';
import { FullBodyPercentage } from '@components/reports/locations/FullBodyPercentage';
import { WarrantyRateByLocation } from '@components/reports/locations/WarrantyRateByLocation';
import { CutGrowthByLocation } from '@components/reports/locations/CutGrowthByLocation';
import { MaterialCutsByLocation } from '@components/reports/locations/MaterialCutsByLocation';
import { ProductRegistrationByLocation } from '@components/reports/locations/ProductRegistrationByLocation';
import { BaseReportPage } from './bases/BaseReportPage';
import { SplitReportContainer } from '@components/SplitReportContainer';
import { ReportTips } from '@components/ReportTips';

interface LocationsProps {
    showTips: boolean;
    dateRange: { startDate: string; endDate: string };
    setDateRange: (dateRange: { startDate: string; endDate: string }) => void;
}

export const Locations = ({ showTips, dateRange, setDateRange }: LocationsProps) => {
    return (
        <BaseReportPage dateRange={dateRange} setDateRange={setDateRange} title={'MO Insights Locations'}>
            {showTips && <ReportTips reportType={REPORT.LOCATION_TIPS} />}

            <SplitReportContainer
                reports={[<CutsByLocationThisMonth key={1} />, <CutsByLocationLastMonth key={2} />]}
            />

            <CutsByLocation dateRange={dateRange} />

            <FullBodyPercentage dateRange={dateRange} />

            <WarrantyRateByLocation dateRange={dateRange} />

            <CutGrowthByLocation dateRange={dateRange} />

            <MaterialCutsByLocation dateRange={dateRange} />

            <ProductRegistrationByLocation dateRange={dateRange} />
        </BaseReportPage>
    );
};
